/**
 * Output Tags Types
 * @constant {Object}
 */
export const OutputTagTypes = Object.freeze({
    TOTAL_ANOMALY_CONFIDENCE: 'total-anomaly-confidence'
});
export const TAG_ENTITY_MAIN_KEY = 'name';
export var TagEntityKeysOP;
(function (TagEntityKeysOP) {
    TagEntityKeysOP["INPUT"] = "input";
    TagEntityKeysOP["MODEL_OUTPUT"] = "model-output";
    TagEntityKeysOP["SCALED"] = "tag-anomaly-scaled";
})(TagEntityKeysOP || (TagEntityKeysOP = {}));
export var TagEntityKeysMT;
(function (TagEntityKeysMT) {
    TagEntityKeysMT["INPUT"] = "input_id";
    TagEntityKeysMT["MODEL_OUTPUT"] = "output_id";
    TagEntityKeysMT["SCALED"] = "tag_anomaly_scaled_id"; // tag-anomaly-scaled
})(TagEntityKeysMT || (TagEntityKeysMT = {}));
export const AGGREGATE_FUNCTIONS = ['avg', 'min', 'max'];
